import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * SrOnly, `.dsk-sr-only`.
 *
 * Source selector: `system.css` `.dsk-sr-only`.
 *
 * For the label a control needs and the eye does not. Never use it to hide
 * something a sighted user also needs; that is what the `hidden` attribute is
 * for, and `system.css` already forces `[hidden] { display: none !important }`
 * so `hidden` cannot lose to a component that sets a display.
 *
 * It is a clip, not a `display: none`, which is the point: the text stays in
 * the accessibility tree and in the reading order.
 */
export const SrOnly = React.forwardRef(function SrOnly(
  { as: Component = 'span', className, ...rest },
  ref,
) {
  return <Component ref={ref} className={cn('dsk-sr-only', className)} {...rest} />;
});
SrOnly.displayName = 'SrOnly';

export default SrOnly;
